"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSEPSelectPaymentComponent = void 0;
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const expresspay_services_1 = require("../../../shared/services/expresspay.services");
const helper_service_1 = require("../../../../mma/shared/services/helper.service");
const index_1 = require("../../../../mma/shared/index");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const _ = require("underscore");
class CSEPSelectPaymentComponent {
    constructor(expressPayService, helperService, modalService, genericContentService) {
        this.expressPayService = expressPayService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.classes = 'col-12';
        this.payMethodList = new Array();
        this.next = new core_1.EventEmitter();
        this.amtToPay = new core_1.EventEmitter();
        this.accNo = new core_1.EventEmitter();
        this.scrollTop();
    }
    ngOnInit() {
        this.loader = true;
        const currUrl = window.location.href;
        if (currUrl.indexOf('fiber') > -1) {
            this.getFiberBillingDetails();
        }
        else {
            this.getBillingDetails();
        }
        this.getBillingAddress();
        this.isAuthenticated();
        this.isScheduledPaymentExist = false;
        this.isScheduledPaymentCancelled = false;
        this.isScheduledCancelledError = false;
        this.myBillAmount = 'PAY-MY-BILL';
        this.isScheduledPaymentExist = false;
        this.isScheduledDateGreaterDueDate = false;
        this.isScheduledDateDueDateSameDay = false;
        this.isValidScheduledDate = true;
        this.scheduledFutureDate = false;
        this.isTodayPayment = true;
        this.isTextPay = false;
        this.isPrimarySubOnAccount = true;
        this.newScheduledDate = new Date();
        this.minDate = this.convertDateToNgbDateStruct(new Date());
        this.selectedDate = this.minDate;
        this.helpUrl = '/help/solution-details/?'
            + 'lob=wireless&lang=en&permaLink=how-to-make-extra-payments-on-your-device--generic-phone--en--0--1&responseId=20--EjWclklgRJJPQQiXgcbjaXR2sBWb0lmt';
        this.getAutoPay();
        this.getScheduledPayment();
    }
    open(content) {
        this.modalRef = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    getAutoPay() {
        this.loader = true;
        this.expressPayService.getAutoPayType().subscribe((data) => {
            if (data !== null && (data.tenderType !== undefined || data.paymentType !== undefined)) {
                this.isAutoPayEnrolled = true;
                if (data.paymentType !== undefined && data.paymentType === 'MAPI') {
                    this.isTextPay = true;
                }
            }
            else {
                this.isAutoPayEnrolled = false;
            }
            this.loader = false;
        }, (err) => {
            this.autopayError = true;
            this.loader = false;
        });
    }
    getScheduledPayment() {
        this.loader = true;
        this.scheduledPaymentLoading = true;
        this.expressPayService.getScheduledPayment()
            .subscribe((getSchdResponse) => {
            if (getSchdResponse == null) {
                this.isScheduledPaymentExist = false;
            }
            else {
                this.isScheduledPaymentExist = getSchdResponse.successful;
                this.isPrimarySubOnAccount = getSchdResponse.primarySubOnAccount;
                if (getSchdResponse.successful) {
                    this.scheduledAmount = getSchdResponse.paymentAmount;
                    if (getSchdResponse.paymentScheduledDate != null) {
                        const year = getSchdResponse.paymentScheduledDate.toString().substring(0, 4);
                        const month = getSchdResponse.paymentScheduledDate.toString().substring(5, 7);
                        const day = getSchdResponse.paymentScheduledDate.toString().substring(8, 10);
                        this.scheduledDate = new Date(month + '/' + day + '/' + year);
                    }
                }
                else {
                    if (!getSchdResponse.primarySubOnAccount) {
                        this.genericContentService.getGenericContent('genericErrorScheduledPaymentExpressPrimary').subscribe((data) => {
                            this.nonPrimarySubMessage = data.contentText;
                            this.loader = false;
                        }, (err) => {
                            this.error = err;
                            this.loader = false;
                        });
                    }
                }
            }
            this.loader = false;
            this.scheduledPaymentLoading = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.scheduledPaymentLoading = false;
        });
    }
    cancelScheduledPayment() {
        this.loader = true;
        this.expressPayService.cancelScheduledPayment()
            .subscribe((schdResponse) => {
            if (schdResponse != null && schdResponse.successful) {
                this.isScheduledPaymentExist = false;
                this.isScheduledPaymentCancelled = true;
                this.isScheduledCancelledError = false;
            }
            else {
                this.error = schdResponse.message;
                this.isScheduledCancelledError = true;
            }
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.isScheduledCancelledError = true;
            this.loader = false;
        });
        this.modalRef.close();
    }
    getBillingAddress() {
        this.loader = true;
        this.expressPayService.getPersonalInformation().subscribe((res) => {
            this.personalInfo = res;
            this.getStartedUrl = '/online-warranty/?mobileNumber=' + this.personalInfo.mobileNumber;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getFiberBillingDetails() {
        this.loader = true;
        this.expressPayService.getFiberBillingDetails()
            .subscribe((fiberBillingSummary) => {
            this.fiberBillingDetails = fiberBillingSummary;
            this.loader = false;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    getBillingDetails() {
        this.loader = true;
        this.expressPayService.getBillingDetails()
            .subscribe((billingSummary) => {
            this.billingDetails = billingSummary;
            this.dueDate = billingSummary.paymentArrangementDueDate ? billingSummary.paymentArrangementDueDate : billingSummary.billPaymentDueDate;
            if (this.billingDetails.billAmountTotalPastDue > 0) {
                this.paymentExtensionEligiblity();
            }
            this.myBillAmount = 'PAY-MY-BILL';
            if (parseFloat(billingSummary.totalAmountDue) > 0) {
                this.payMethodList.push({
                    id: 'PAY-MY-BILL',
                    label: '$' + billingSummary.totalAmountDue.toFixed(2) + ' Full Balance'
                });
            }
            else {
                this.myBillAmount = 'PAY-CUSTOM-BILL';
            }
            if (billingSummary.billAmountTotalPastDue !== null && billingSummary.billAmountTotalPastDue !== undefined) {
                if (parseFloat(billingSummary.billAmountTotalPastDue) > 0) {
                    this.payMethodList.push({
                        id: 'PAY-PAST-DUE',
                        label: '$' + billingSummary.billAmountTotalPastDue.toFixed(2) + ' Past Due Amount'
                    });
                }
            }
            this.payMethodList.push({
                id: 'PAY-CUSTOM-BILL',
                label: 'Other Amount'
            });
            this.accNo.emit(this.billingDetails.accountNumber);
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    nextSection(type, fullPlanCost, differentAmt, pastDueAmount) {
        differentAmt = this.trimSpecialCharFromAmt(differentAmt);
        differentAmt = parseFloat(differentAmt);
        if (this.isScheduledPaymentExist && this.scheduledFutureDate) {
            this.myBillAmount = 'PAY-MY-BILL';
        }
        else {
            if (type === 'PAY-MY-BILL') {
                const paymentDetails = {
                    'amountToPay': fullPlanCost,
                    'payInFull': true,
                    'payPastDueBalance': false,
                    'isScheduledPaymentExist': this.isScheduledPaymentExist,
                    'scheduledFutureDate': this.scheduledFutureDate,
                    'newScheduledDate': this.newScheduledDate
                };
                this.amtToPay.emit(paymentDetails);
            }
            else if (type === 'PAY-PAST-DUE') {
                const paymentDetails = {
                    'amountToPay': pastDueAmount,
                    'payInFull': false,
                    'payPastDueBalance': true,
                    'isScheduledPaymentExist': this.isScheduledPaymentExist,
                    'scheduledFutureDate': this.scheduledFutureDate,
                    'newScheduledDate': this.newScheduledDate
                };
                this.amtToPay.emit(paymentDetails);
            }
            else {
                const paymentDetails = {
                    'amountToPay': differentAmt,
                    'payInFull': false,
                    'payPastDueBalance': false,
                    'isScheduledPaymentExist': this.isScheduledPaymentExist,
                    'scheduledFutureDate': this.scheduledFutureDate,
                    'newScheduledDate': this.newScheduledDate
                };
                this.amtToPay.emit(paymentDetails);
            }
            this.next.emit(true);
        }
    }
    paymentExtensionEligiblity() {
        this.loader = true;
        this.expressPayService.getPaymentExtensionEligiblity()
            .subscribe((res) => {
            if (!res.eligibility) {
                this.genericContentService.getGenericContent('genericErrorMsgPaymentExtensionFailed').subscribe((data) => {
                    this.eligiblityDetails = data.contentText;
                    this.loader = false;
                }, (err) => {
                    this.error = err;
                    this.loader = false;
                });
            }
            else {
                this.showSection = true;
                this.loader = false;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.showSection = false;
        });
    }
    extendPayment() {
        this.loader = true;
        this.expressPayService.getExtendPaymentDate().pipe(operators_1.finalize(() => this.genericContentService.getGenericContent('genericPaymentExtensionSuccess').subscribe((res) => {
            this.paymentArrSuccessText = res.contentText;
            this.loader = false;
            if (this.error !== undefined) {
                this.paymentArrSuccessText = null;
            }
            else {
                this.paymentArrSuccessText = this.paymentArrSuccessText.toString().replace('EXTENDED_DATE', this.extendedDate.billDueDate);
                this.billingDetails.paymentArrangementDueDate = this.extendedDate.billDueDate;
                this.dueDate = this.billingDetails.paymentArrangementDueDate;
            }
            this.modelRef.close();
        }, (err) => {
            this.error = err;
            this.loader = false;
        })))
            .subscribe((res) => {
            this.extendedDate = res;
            this.dueDate = this.extendedDate.billDueDate;
            this.modelRef.close();
        }, (err) => {
            this.error = err;
            this.loader = false;
            this.scrollTop();
            this.modelRef.close();
        });
    }
    convert(event) {
        event = this.trimSpecialCharFromAmt(event);
        this.differentAmount = parseFloat(event);
    }
    trimSpecialCharFromAmt(event) {
        if (event && event.includes(',')) {
            event = event.replaceAll(',', '');
        }
        return event;
    }
    onFocus(diffAmountModel) {
        this.myBillAmount = 'PAY-CUSTOM-BILL';
    }
    onKey(event) {
        this.differentAmount = event.target.value;
    }
    resetDiffAmount() {
        this.diffAmt = '';
    }
    openMyModal() {
        event.preventDefault();
        this.myBillAmount = 'PAY-PAST-DUE';
        this.modelRef = this.modalService.open(this.pastDuePopup, { windowClass: 'dark-modal' });
    }
    openPaymentArrModal() {
        event.preventDefault();
        this.modelRef = this.modalService.open(this.paymentArrPopup, { windowClass: 'dark-modal' });
    }
    close() {
        this.modelRef.close();
    }
    scrollTop() {
        window.scrollTo(0, 200);
    }
    openTT() {
        this.tooltip.open();
    }
    closeTT() {
        this.tooltip.close();
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : ((event.charCode >= 48 && event.charCode <= 57) || event.charCode === 46);
    }
    selectedPayBillMethod() {
        this.myBillAmount = 'PAY-MY-BILL';
    }
    isAuthenticated() {
        this.loader = true;
        this.expressPayService.loginAuthentication().subscribe((data) => {
            if (_.isEmpty(data)) {
                this.hidePage = true;
                this.helperService.onNavigate('/my_account/personal/express-pay/');
            }
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
    convertDateToNgbDateStruct(date) {
        return date ? {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        } : null;
    }
    convertNgbDateStructToString(d) {
        if (d === null) {
            return '';
        }
        const dateStr = [
            d.year,
            (d.month < 10 ? ('0' + d.month) : d.month),
            (d.day < 10 ? ('0' + d.day) : d.day)
        ].join('-');
        const dateWithTimezone = new Date(dateStr);
        dateWithTimezone.setMinutes(dateWithTimezone.getMinutes() + dateWithTimezone.getTimezoneOffset());
        return this.convertDateToString(dateWithTimezone);
    }
    convertNgbDateStructToDate(d) {
        if (d === null) {
            return null;
        }
        const dateStr = [
            d.year,
            (d.month < 10 ? ('0' + d.month) : d.month),
            (d.day < 10 ? ('0' + d.day) : d.day)
        ].join('-');
        const dateWithTimezone = new Date(dateStr);
        dateWithTimezone.setMinutes(dateWithTimezone.getMinutes() + dateWithTimezone.getTimezoneOffset());
        return dateWithTimezone;
    }
    convertDateToString(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    }
    convertStringToDate(dateStr) {
        const dateWithTimezone = new Date(dateStr);
        dateWithTimezone.setMinutes(dateWithTimezone.getMinutes() + dateWithTimezone.getTimezoneOffset());
        return dateWithTimezone;
    }
    compareTwoDates(date1, date2) {
        if (date1.getFullYear() > date2.getFullYear()) {
            return 1;
        }
        else if (date1.getFullYear() < date2.getFullYear()) {
            return -1;
        }
        else {
            if (date1.getMonth() > date2.getMonth()) {
                return 1;
            }
            else if (date1.getMonth() < date2.getMonth()) {
                return -1;
            }
            else {
                if (date1.getDate() > date2.getDate()) {
                    return 1;
                }
                else if (date1.getDate() < date2.getDate()) {
                    return -1;
                }
                else {
                    return 0;
                }
            }
        }
    }
    onDateChange(event) {
        this.newScheduledDate = this.convertNgbDateStructToDate(this.selectedDate);
        this.setFlags();
        this.loader = false;
    }
    setFlags() {
        this.isScheduledPaymentCancelled = false;
        this.isScheduledCancelledError = false;
        if (this.newScheduledDate == null || this.newScheduledDate.toString().length === 0) {
            this.scheduledFutureDate = false;
            this.isValidScheduledDate = true;
            this.isScheduledDateGreaterDueDate = false;
            this.isScheduledDateDueDateSameDay = false;
            this.isTodayPayment = true;
        }
        else {
            const parsedDate = Date.parse(this.newScheduledDate);
            if (isNaN(parsedDate)) {
                this.scheduledFutureDate = false;
                this.isValidScheduledDate = false;
                this.isScheduledDateGreaterDueDate = false;
                this.isScheduledDateDueDateSameDay = false;
                this.isTodayPayment = true;
            }
            else {
                this.isValidScheduledDate = true;
                if (this.compareTwoDates(new Date(this.newScheduledDate), new Date()) === 0) {
                    this.isScheduledDateGreaterDueDate = false;
                    this.isScheduledDateDueDateSameDay = false;
                    this.scheduledFutureDate = false;
                }
                else {
                    this.scheduledFutureDate = true;
                    if (this.compareTwoDates(new Date(this.newScheduledDate), new Date(this.dueDate)) > 0) {
                        this.isScheduledDateGreaterDueDate = true;
                        this.isScheduledDateDueDateSameDay = false;
                    }
                    else if (this.compareTwoDates(new Date(this.newScheduledDate), new Date(this.dueDate)) === 0) {
                        this.isScheduledDateGreaterDueDate = false;
                        if (this.isAutoPayEnrolled && !this.autopayError && !this.isTextPay) {
                            this.isScheduledDateDueDateSameDay = true;
                        }
                        else {
                            this.isScheduledDateDueDateSameDay = false;
                        }
                    }
                    else {
                        this.isScheduledDateGreaterDueDate = false;
                        this.isScheduledDateDueDateSameDay = false;
                    }
                }
                if (this.isScheduledPaymentExist && (this.scheduledDate !== 'undefined') && (this.scheduledDate != null)) {
                    if (this.compareTwoDates(new Date(this.newScheduledDate), new Date()) === 0) {
                        this.isTodayPayment = true;
                    }
                    else {
                        this.isTodayPayment = false;
                    }
                }
            }
        }
    }
}
exports.CSEPSelectPaymentComponent = CSEPSelectPaymentComponent;
//# sourceMappingURL=selectpayment.component.js.map